import { type App, createApp, ref, watch } from "vue";
import DsModalAlert from "../modal-alert/ds-modal-alert.vue";
import { DsModalAlertModel } from "../modal-alert/ds-modal-alert-model";

/**
 * Mount DS alert component
 * @param {Object} props
 * @param title - title for alert
 * @param subText - text for alert
 * @param btnCloseText - text for close button
 * @param errorCode - error code
 * @param animate - show animation
 * @param bottomDividerVisible - show bottom divider
 * @param alertImageSrc - image for alert
 * @param modalClass - additional class for modal
 * @param buttonClass - additional class for button
 * @param href - url link
 * @param btnHrefText - text for link
 */
export function showAlert(props: DsModalAlertModel) {
    const isVisible = ref(true);

    const root = document.createElement("div");

    const alertRef: App<Element> = createApp(DsModalAlert, {
        ...props,
        onUnmounted: () => {
            root.remove();
        },
    });

    alertRef.mount(root);

    watch(isVisible, (newVal) => {
        if (!newVal) {
            alertRef.unmount();
        }
    });

    return {
        isVisible,
    };
}
